import * as React from 'react';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import PharmacyMapComponent from '../common/PharmacyMapComponent';
import styled from '@emotion/styled';
import { Label } from '@blueprintjs/core';
import { TLCode } from '../../common/enums';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';

const MapContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0.495;
`;

const Maps = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

interface PharmacyMapPanelState {
  initialZoomCalculatedDay: boolean;
  initialZoomCalculatedNight: boolean;
}

interface PharmacyMapPanelProps extends WithTranslateProps {
  pharmacyDetails: Instance<typeof PharmacyDetails>;
  PharmacyDetailedStore?: any;
  PharmacyStore?: any;
}

@observer
class PharmacyMapPanel extends React.Component<PharmacyMapPanelProps, PharmacyMapPanelState> {
  state = {
    initialZoomCalculatedDay: false,
    initialZoomCalculatedNight: false,
  } as PharmacyMapPanelState;

  fitBounds = (type: 'day' | 'night', map: google.maps.Map) => {
    if (
      (type === 'day' && !this.state.initialZoomCalculatedDay) ||
      (type === 'night' && !this.state.initialZoomCalculatedNight)
    ) {
      const { pharmacyDetails, PharmacyStore } = this.props;
      // @ts-ignore
      const bounds = new window.google.maps.LatLngBounds();
      if (pharmacyDetails.pharmacyNeighbors) {
        pharmacyDetails.pharmacyNeighbors
          .map((item) => {
            return PharmacyStore!.getById(item.neighborId);
          })
          .forEach(
            (d) =>
              // @ts-ignore
              bounds.extend(new window.google.maps.LatLng(d.latitude, d.longitude)),
            // @ts-ignore
          );
      } else {
        // @ts-ignore
        bounds.extend(new window.google.maps.LatLng(pharmacyDetails.latitude, pharmacyDetails.longitude));
      }
      if (type === 'day') {
        map.fitBounds(bounds);
        this.setState({ initialZoomCalculatedDay: true });
      } else {
        map.fitBounds(bounds);
        this.setState({ initialZoomCalculatedNight: true });
      }
    }
  };

  render() {
    const { PharmacyStore, pharmacyDetails, translate } = this.props;

    return (
      <div>
        <b>
          ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails!.apbNumber}&nbsp;-&nbsp;{pharmacyDetails!.name}
          &nbsp;-&nbsp;{pharmacyDetails!.address},&nbsp;
          {pharmacyDetails!.zipCode}&nbsp;
          {pharmacyDetails!.city}
        </b>

        <Maps>
          <MapContainer>
            <Label
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              {translate(TLCode.DUTYASSIGNMENT_DAY_ZONES)}
              {' ' + pharmacyDetails.minDistance! / 1000}
              {translate(TLCode.DUTYASSIGNMENT_DAY_ZONES2)}
              {pharmacyDetails.maxDistance! / 1000 + 'km'}
            </Label>
            <PharmacyMapComponent
              center={{ lat: Number(pharmacyDetails.latitude), lng: Number(pharmacyDetails.longitude) }}
              places={[
                {
                  pharmacyId: pharmacyDetails.pharmacyId,
                  apbNumber: pharmacyDetails.apbNumber,
                  name: pharmacyDetails.name,
                  address: pharmacyDetails.address,
                  zipCode: pharmacyDetails.zipCode,
                  city: pharmacyDetails.city,
                  phone: pharmacyDetails.phone,
                  latitude: pharmacyDetails.latitude,
                  longitude: pharmacyDetails.longitude,
                  id: pharmacyDetails.apbNumber,
                  minDistance: pharmacyDetails.minDistance,
                  maxDistance: pharmacyDetails.maxDistance,
                  level: pharmacyDetails.level,
                },
              ]}
              neighbors={pharmacyDetails.pharmacyNeighbors
                .filter(
                  (elem) =>
                    elem.distance == null ||
                    pharmacyDetails.maxDistance == null ||
                    elem.distance! <= pharmacyDetails.maxDistance!,
                )
                .map((item) => {
                  return PharmacyStore!.getById(item.neighborId);
                })}
              onMapLoad={(map: google.maps.Map) => this.fitBounds('day', map)}
            />
          </MapContainer>
          <MapContainer>
            <Label
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
              }}
            >
              {translate(TLCode.DUTYASSIGNMENT_NIGHT_ZONES)}
              {' ' + pharmacyDetails.minDistance2! / 1000}
              {translate(TLCode.DUTYASSIGNMENT_NIGHT_ZONES2)}
              {pharmacyDetails.maxDistance2! / 1000 + 'km'}
            </Label>
            <PharmacyMapComponent
              center={{ lat: Number(pharmacyDetails.latitude), lng: Number(pharmacyDetails.longitude) }}
              places={[
                {
                  pharmacyId: pharmacyDetails.pharmacyId,
                  apbNumber: pharmacyDetails.apbNumber,
                  name: pharmacyDetails.name,
                  address: pharmacyDetails.address,
                  zipCode: pharmacyDetails.zipCode,
                  city: pharmacyDetails.city,
                  phone: pharmacyDetails.phone,
                  latitude: pharmacyDetails.latitude,
                  longitude: pharmacyDetails.longitude,
                  id: pharmacyDetails.apbNumber,
                  minDistance: pharmacyDetails.minDistance2,
                  maxDistance: pharmacyDetails.maxDistance2,
                },
              ]}
              neighbors={
                pharmacyDetails.pharmacyNeighbors &&
                pharmacyDetails.pharmacyNeighbors
                  .filter(
                    (elem) =>
                      elem.distance == null ||
                      pharmacyDetails.maxDistance2 == null ||
                      elem.distance! <= pharmacyDetails.maxDistance2!,
                  )
                  .map((item) => {
                    return PharmacyStore!.getById(item.neighborId);
                  })
              }
              onMapLoad={(map: google.maps.Map) => this.fitBounds('night', map)}
            />
          </MapContainer>
        </Maps>
      </div>
    );
  }
}

export default withTranslate(PharmacyMapPanel);
